<template>
  <div class="page">
    <!-- 内容区域 -->
    <div ref="captureArea" class="content">
      <!-- 你的内容 -->
      <div v-for="(item, index) in 100" :key="index">哈哈哈哈哈{{ index }}</div>
    </div>

    <!-- 生成按钮 -->
    <van-button type="primary" block @click="generateImage">
      生成长图
    </van-button>

    <!-- 图片预览弹窗 -->
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="overlay-content" @click.stop>
        <div class="tip">长按图片可保存到相册</div>
        <img :src="imageUrl" class="long-image" />
        <van-icon name="cross" class="close-btn" @click="showOverlay = false" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      showOverlay: false,
      imageUrl: ""
    };
  },

  methods: {
    async generateImage() {
      this.$toast.loading({ message: "生成中...", forbidClick: true });

      try {
        const element = this.$refs.captureArea;

        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2,
          backgroundColor: "#ffffff",
          width: element.scrollWidth,
          height: element.scrollHeight
        });

        this.imageUrl = canvas.toDataURL("image/jpeg", 0.9);
        this.$toast.clear();
        this.showOverlay = true;
      } catch (error) {
        this.$toast.fail("生成失败");
      }
    }
  }
};
</script>

<style scoped>
.overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 20px;
}

.tip {
  color: white;
  font-size: 16px;
  margin-bottom: 20px;
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 20px;
}

.long-image {
  max-width: 90%;
  max-height: 70%;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Test/Test.vue